import { toNumber } from './to-number.js';
export default (formattedCurrencyString) => {
    const asNumber = toNumber(formattedCurrencyString);
    return Math.ceil(asNumber * 100);
};
//# sourceMappingURL=currency-string-to-cents.js.map